<div class="wrapper">
  <div class="cuerpo">

    <h1 class="tp-navandu line-navandu">FIRMANTES</h1>
    <div class="input-field col s12 buscador">
      <input id="filter" type="text" (keyup)="applyFilter($event)">
      <label for="filter" data-error="Ingrese un dato valido" data-success="">
        <button mat-icon-button type="button" (click)="search()">
          <i class="material-icons">search</i>
        </button>
        
      </label>
    </div>

    @if (loading) {
      <app-spinner></app-spinner>
    } @else {
      <div class="select-state">
        <button mat-icon-button class="refrescar action-icon-btn" (click)="sign('new')" matTooltip="Nuevo firmante"
          matTooltipPosition="above" aria-label="Nuevo firmante">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>

            <table mat-table [dataSource]="dataSource" class="tabla">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Nombre </th>
          <td mat-cell *matCellDef="let element"> {{element.name + " " + element.lastName}}</td>
        </ng-container>
        <ng-container matColumnDef="idn">
          <th mat-header-cell *matHeaderCellDef> Documento </th>
          <td mat-cell *matCellDef="let element"> {{element.idn}} </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Correo </th>
          <td mat-cell *matCellDef="let element"> {{element.email}} </td>
        </ng-container>
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef> Teléfono </th>
          <td mat-cell *matCellDef="let element"> {{element.phone}} </td>
        </ng-container>
        <ng-container matColumnDef="creationDate">
          <th mat-header-cell *matHeaderCellDef> F. Creación </th>
          <td mat-cell *matCellDef="let element"> {{element.creationDate | date:'dd-MM-yyyy HH:mm'}} </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef> Acción </th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button class="action-icon-btn" (click)="sign(element.uuid)" matTooltip="Editar"
              matTooltipPosition="above" aria-label="Editar">
              <mat-icon>send</mat-icon>
            </button>
            <button mat-icon-button class="action-icon-btn" (click)="delete(element.uuid)" matTooltip="Eliminar"
              matTooltipPosition="above" aria-label="Eliminar">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    }
    <mat-paginator [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>

  @if (viewForm) {
    <div class="ver-firmante">
      <form name="entrar" class="formulario form-gen-doc" autocomplete="off" [formGroup]="signerForm"
        (ngSubmit)="onSubmit()">
        <div class="row documento">
          <h2 class="tp-navandu"> INFORMACIÓN DEL FIRMANTE </h2>
          <div class="flex-row">
            <mat-form-field class="example-full-width">
              <mat-label>Número de documento</mat-label>
              <input type="text" matInput formControlName="idn" required>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Tipo de documento</mat-label>
              <mat-select required formControlName="typeOfIdn">
                <mat-option value="Alias">Alias</mat-option>
                <mat-option value="DNI">DNI</mat-option>
                <mat-option value="NIF">NIF</mat-option>
                <mat-option value="NIE">NIE</mat-option>
                <mat-option value="CIF">CIF</mat-option>
                <mat-option value="PASS">PASS</mat-option>
                <mat-option value="RUC">RUC</mat-option>
                <mat-option value="Cedula">Cedula</mat-option>
                <mat-option value="Otro">Otro</mat-option>
              </mat-select>
              @if (signerForm.controls.typeOfIdn.hasError('required')) {
                <mat-error>
                  Tipo de documento <strong>requerido</strong>
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="flex-row">
            <mat-form-field>
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="name" required>
              @if (signerForm.controls.name.hasError('required')) {
                <mat-error>
                  Nombre <strong>requerido</strong>
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>Apellidos</mat-label>
              <input matInput formControlName="lastName" required>
              @if (signerForm.controls.lastName.hasError('required')) {
                <mat-error>
                  Apellido <strong>requerido</strong>
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="flex-row filatres">
            <div class="phone-group">
              <mat-form-field class="prefix-section">
                <mat-select required formControlName="countryPhone">
                  @for (phonePrefix of phonePrefixes; track phonePrefix) {
                    <mat-option [value]="phonePrefix.prefix">
                      {{phonePrefix.code}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="phone">
                <mat-label>Móvil para sms de firma</mat-label>
                <input matInput formControlName="phone">
                @if (signerForm.controls.phone.hasError('required')) {
                  <mat-error>
                    Móvil <strong>requerido</strong>
                  </mat-error>
                }
                @if (signerForm.controls.phone.hasError('minlength') || signerForm.controls.phone.hasError('maxlength')) {
                  <mat-error
                    >
                    Móvil <strong>debe tener 9 caracteres</strong>
                  </mat-error>
                }
                @if (signerForm.controls.phone.hasError('pattern')) {
                  <mat-error>
                    Móvil <strong>debe ser numérico</strong>
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <mat-form-field class="email">
              <mat-label>Email</mat-label>
              <input matInput placeholder="Ex. pat@example.com" formControlName="email">
              @if (signerForm.controls.email.hasError('email') && !signerForm.controls.email.hasError('required')) {
                <mat-error
                  >
                  Por favor ingrese un correo válido
                </mat-error>
              }
              @if (signerForm.controls.email.hasError('required')) {
                <mat-error>
                  Correo <strong>requerido</strong>
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="flex-row filatres">
            <mat-form-field class="email">
              <mat-label>Email</mat-label>
              <input matInput placeholder="Ex. pat@example.com" formControlName="email2">
              @if (signerForm.controls.email.hasError('email2')) {
                <mat-error>
                  Por favor ingrese un correo válido
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="enviar2">
          <input type="button" (click)="cancel()" class="boton volver2" value="Cancelar">
          <input type="submit" class="boton volver2" value="Guardar">
        </div>
      </form>
    </div>
  }

  @if (askDelete) {
    <div class="ver-detalle">
      <div class="datos-detalle">
        <div class="row documento">
          <h2 class="tp-navandu"> ¿Seguro que desea eliminar firmante? </h2>
          <div class="enviar2">
            <input type="button" (click)="beDelete(false)" class="boton volver2" value="Cancelar">
            <input type="button" (click)="beDelete(true)" class="boton volver2" value="Eliminar">
          </div>
        </div>
      </div>
    </div>
  }